// utils/modosOptions.js

export const modosOptions = [
  {
    value: "Nota",
    label: "Nota Avanzada",
    icon: "newspaper",
    endpoint: "articles",
    hint: "Crear un artículo seleccionando múltiples fuentes desde links, textos pegados o subiendo archivos PDF. Se puede combinar con una o más preguntas a ChatPTS y con notas de la DB. Permite copiar el estilo de otra nota y generar varios títulos.",
  },
  {
    value: "Reinterpretar",
    label: "Reinterpretar / reescribir / traducir",
    icon: "documents",
    endpoint: "reinterpretations",
    hint: "Reescribir una nota o traducirla a otro idioma. Se pueden incluir uno o más link, o uno ó más textos pegados, o ambas cosas.",
  },
  {
    value: "Editorial",
    label: "Modo editorial / apuntes",
    icon: "chatbubble",
    endpoint: "editorials",
    hint: "Partiendo de uno o más artículos de otros medios, textuales, etc permite crear una nota rápida agregando algo de línea política",
  },
  {
    value: "Placas",
    label: "Modo placas",
    icon: "albums",
    endpoint: "placas",
    hint: "Crea el guion de un carrusel de placas para Instagram o similar, a partir de un texto pegado o un link.",
  },
  {
    value: "Twitter",
    label: "Hilo de TW",
    icon: "layers",
    endpoint: "threads",
    hint: "Crea un hilo de Twitter o similar a partir de un texto pegado o un link.",
  },
  {
    value: "Guion",
    label: "Guion de video",
    icon: "videocam",
    endpoint: "scripts",
    hint: "Crea un guion de video para TikTok, reel o similar a partir de un texto pegado o un link.",
  },
  {
    value: "Corrector",
    label: "Corrector de Texto",
    icon: "text",
    endpoint: "corrections",
    hint: "Corrige gramatical y ortográficamente cualquier texto sin alterar el contenido.",
  },
  {
    value: "Títulos",
    label: "Generar Títulos + Bajada",
    icon: "document",
    endpoint: "titles",
    hint: "Genera varios títulos y bajadas a partir de un texto pegado o un link (de una nota ya terminada).",
  },
  {
    value: "Parsear",
    label: "Probar subir archivo PDF",
    icon: "archive",
    endpoint: "",
    hint: "Sube un archivo PDF y prueba el parseo de texto para comprobar si un archivo se puede usar o no en el modo de Nota Avanzada.",
  },
  {
    value: "Descargar",
    label: "Probar descargar nota",
    icon: "archive",
    endpoint: "",
    hint: "Prueba descargar una nota desde un link para comprobar si se puede usar o no en el modo de Nota Avanzada.",
  },
];
